enum WorkSafeBcAnatomicalPosition {
    Left = 1,
    Right,
    LeftAndRight,
    NotApplicable
}

export { WorkSafeBcAnatomicalPosition };
